import React, { HTMLProps } from 'react';

import Props from './SocialButtonsInterface';
import { FacebookIcon, FacebookIconContainer, SocialButton } from './styles';

export function FacebookForm({
  xsrft,
  action,
  children,
  optIn,
  onClick,
  onSubmit,
  redirectUrl,
  target = '_self',
  className,
  turnstileToken,
}: Props) {
  const url = action === 'join' ? '/join' : '/log_in';

  const formProps: HTMLProps<HTMLFormElement> = {
    id: 'facebook_form',
    method: 'POST',
    action: url,
    noValidate: true,
    onSubmit: onSubmit,
    target: target,
  };

  if (target === '_blank') {
    formProps.rel = 'opener';
  }

  return (
    <form {...formProps}>
      <input type="hidden" name="service" value="facebook" />
      <input type="hidden" name="action" value={action} />
      <input type="hidden" name="token" value={xsrft} />
      {turnstileToken !== null && (
        <input type="hidden" name="cf-turnstile-response" value={`${turnstileToken}`} />
      )}
      {redirectUrl && <input type="hidden" name="redirect" value={redirectUrl} />}
      {optIn !== null && <input type="hidden" name="marketing_opt_in" value={`${optIn}`} />}
      <SocialButton
        className={className}
        icon={
          <FacebookIconContainer>
            <FacebookIcon />
          </FacebookIconContainer>
        }
        format="secondary"
        onClick={() => onClick?.()}
      >
        {children}
      </SocialButton>
    </form>
  );
}
